import { Badge, Card } from 'tunggal';
import React from 'react';
export default {
  Badge,
  Card,
  React
};